import {Component} from "@angular/core";
import {FamilyAlbum} from "../../../model/family-album";
import {BusinessService} from "../../../services/data/business.service";
import {Router} from "@angular/router";
import {CurrentBusinessService} from "../../../services/communication/currentBusinessService";

@Component({
  selector: 'event-creation',
  template: require('./event-creation.component.html'),
  styles: [
    require('./event-creation.component.scss')
  ]
})

export class EventCreationComponent {
  model = new FamilyAlbum();
  submitted = false;

  date:number;
  isPublic:boolean = false;
  isDateValid:boolean = false;

  myDatePickerOptions = {
    todayBtnTxt: 'Aujourd\'hui',
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    inline: false,
    locale: 'fr',
    selectionTxtFontSize: '16px'
  };

  constructor(private businessService:BusinessService, private router:Router,
              private currentBusinessService: CurrentBusinessService) {
  }

  back(): void {
    this.router.navigateByUrl('/home/events');
  }

  onDateChanged(event:any) {
    if (event.formatted != undefined && event.formatted != "") {
      this.isDateValid = true;
      this.date = event.epoc*1000;
    } else {
      this.isDateValid = false;
    }
  }

  createEvent() {
    this.model.date = this.date;

    this.businessService.createEvent(this.currentBusinessService.currentBusiness.id, this.model)
      .subscribe(
        event => {
          this.router.navigateByUrl('/event/'+event.id);
        },
        error => {
          console.log(error)
        }
      );
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/event/event-creation/event-creation.component.ts